/** The action log's query keys, shared by the list and its deep-linked entry. */
export const actionLogKeys = {
  incidents: (customerId: string) => ['event-management', 'action-log', 'incidents', customerId] as const,
  reports: (customerId: string) => ['event-management', 'action-log', 'reports', customerId] as const,
};
